// Cross-origin presigned S3 URLs don't reliably honor a plain <a download>
// tag, so fetch the bytes into a same-origin blob URL first — same pattern
// already used for PDF downloads in Services/apiService.js's verifyDOB.
export async function downloadReportFile(url, filename) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to download report (HTTP ${response.status})`);
  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}
